/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Status_RevokedInputs */

const vi_api_keys_status_revoked = /** @type {(inputs: Api_Keys_Status_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã thu hồi`)
};

/**

* @param {Api_Keys_Status_RevokedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_status_revoked = /** @type {((inputs?: Api_Keys_Status_RevokedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Status_RevokedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_status_revoked(inputs)
});